<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('stockIn.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockIn.pageTitle'),
            href: '/admin/stock-in'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3">
            <form class="form-horizontal">
              <div class="row">
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label"
                    >{{ $t('stockIn.purchaseNumber') }}</label>
                    <div class="col-md-7">
                      <Ponumber 
                        v-model="model" 
                        :validate="errors"
                        @loading="(value) => loading = value"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label required"
                    >{{ $t('stockIn.invoiceNumber') }}</label>
                    <div class="col-md-7">
                      <input 
												v-model="model.invoice_no" 
												type="text" 
												class="form-control"
												:class="{ 'is-invalid': errors.has('invoice_no')}" 
											/>
											<div class="invalid-feedback" v-if="errors.has('invoice_no')">
												{{ errors.first('invoice_no') }}
											</div>
                    </div>
                  </div>
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label required"
                    >{{ $t('stockIn.vendor') }}</label>
                    <div class="col-md-7">
                      <a-select 
												v-model="model.vendor_id" 
												:options="vendorList"
                        showSearch
                        :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
												class="ts-w-full"
												:class="{ 'is-invalid': errors.has('vendor_id')}"  
											></a-select>
											<div class="invalid-feedback" v-if="errors.has('vendor_id')">
												{{ errors.first('vendor_id') }}
											</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 ts-space-y-3">
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label required"
                    >{{ $t('stockIn.stockInDate') }}</label>
                    <div class="col-md-7">
                      <a-date-picker
                        class="ts-w-full"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                        v-model="model.stock_in_date"
												:class="{ 'is-invalid': errors.has('stock_in_date')}"  
                      ></a-date-picker>
											<div class="invalid-feedback" v-if="errors.has('stock_in_date')">
												{{ errors.first('stock_in_date') }}
											</div>
                    </div>
                  </div>
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label required"
                    >{{ $t('stockIn.location') }}</label>
                    <div class="col-md-7">
                      <a-select
                        class="ts-w-full"
                        v-model="model.location_id"
                        :options="locationList"
                        showSearch
                        :disabled="true"
                        :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
												:class="{ 'is-invalid': errors.has('location_id')}" 
                      ></a-select>
											<div class="invalid-feedback" v-if="errors.has('location_id')">
												{{ errors.first('location_id') }}
											</div>
                    </div>
                  </div>
                  <div class="row">
                    <label
                      class="col-md-3 form-col-label control-label required"
                    >{{ $t('stockIn.fixRate') }}</label>
                    <div class="col-md-7">
                      <input v-model="model.fix_rate" type="text" readonly class="form-control" />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3 ts-mt-4">
            <ProductDetail v-model="model" :validate="errors" />
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-space-x-4 ts-flex ts-justify-end">
              <ts-button
                @click.prevent="$router.push({ name: 'stock-in' })"
              >{{ $t('cancel') }}</ts-button>
              <ts-button
                color="primary"
                outline
                :waiting="waiting_new"
                @click.prevent="saveAddNew"
              >{{ $t('savePrint') }}</ts-button>
              <ts-button color="primary" :waiting="waiting" @click.prevent="save">{{ $t('save') }}</ts-button>
            </div>
          </div>
        </ts-loading-banner>
        <a-modal
          :title="$t('pdf')"
          width="50%"
          v-model="show_pdf"
          :footer="null"
        >
          <ts-preview-pdf v-model="waiting_new" :src="src" />
        </a-modal>

      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import Ponumber from './components/purchase-order-number'
import ProductDetail from './components/product-detail'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'stockInCreate',
  components: {
    Ponumber,
    ProductDetail
  },
  data() {
    return {
      errors: new Errors(),
			loading: false,
			waiting_new: false,
      waiting: false,
      show_pdf: false,
      src: null,
      model: {
        stock_in_id: null,
        location_id: null,
        invoice_no: null,
        stock_in_date: moment().format('DD-MM-YYYY'),
        po_id: null,
        vendor_id: null,
        fix_rate: 4000,
        product_detail: [
        ]
      }
    }
  },
  async created() {
    this.loading = true
    await this.fetchResource().finally(() => (this.loading = false))
    this.autoSelectMainWarehouse()
  },
  computed: {
    ...mapState('stock/stockIn', ['locations']),
    vendorList() {
      return this.$store.state.stock.stockIn.suppliers.map(el => ({
        value: el.vendor_id,
        label: el.vendor_name
      }))
    },
    locationList() {
      return this.$store.state.stock.stockIn.locations.map(el => ({
        value: el.location_id,
        label: el.location_name_en
      }))
    }
  },
  methods: {
		...mapActions('stock/stockIn', ['fetchResource', 'store']),
		save() {
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)  
          this.$router.push({ name: 'stock-in' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    saveAddNew() {
      this.waiting_new = true
      this.show_pdf = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.src = response.url
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting_new = false
        })
		},
    autoSelectMainWarehouse(){
      this.model.location_id = this.$store.state.authUser.user.warehouses.filter(w => w.pivot.is_default == true).reduce((i,v) => i = v.location_id ,null)
    },
		clearInput() {
      this.model.stock_in_id = null
      this.model.location_id = null
      this.model.invoice_no = null
      this.model.stock_in_date = moment().format('DD-MM-YYYY'),
      this.model.po_id = null
      this.model.vendor_id = null
      this.model.fix_rate = 4000
      this.model.product_detail = [
          {
            product_id: null,
            uom_id: null,
            qty: 1,
            cost: 0,
            discount_rate: 0,
            discount_type: '%',
            total_after_discount: null,
            vat_rate: 0,
            vat_amount: 0,
            grand_total: 0,
            expiry_date: null,
            is_expire: false,
            product_grade: '',
          }
        ]
      this.errors = new Errors()
		}
	},
	beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/stockIn/CLEAR_SETUP')
    next()
  }
}
</script>